// Freezes the page where it is (mobile menu, popups). overflow:hidden on <html> is not
// enough here: the sticky header lost its place and jumped off screen.
let lockedAt = -1;
let owners = 0;

export function lockScroll(): void {
	owners += 1;

	if (lockedAt >= 0) {
		return;
	}

	const body = document.body;
	const header = document.querySelector<HTMLElement>('[data-armada-header]');
	const holder = header?.parentElement;

	lockedAt = window.scrollY;
	body.style.top = `-${lockedAt}px`;
	body.style.paddingRight = `${window.innerWidth - document.documentElement.clientWidth}px`;

	// The header is pinned while locked; keep its space so nothing shifts.
	if (header && holder) {
		holder.style.paddingTop = `${header.offsetHeight}px`;
	}

	document.documentElement.classList.add('armada-scroll-locked');
}

export function unlockScroll(): void {
	owners = Math.max(0, owners - 1);

	if (owners > 0 || lockedAt < 0) {
		return;
	}

	const y = lockedAt;
	const header = document.querySelector<HTMLElement>('[data-armada-header]');

	lockedAt = -1;
	document.documentElement.classList.remove('armada-scroll-locked');
	document.body.style.top = '';
	document.body.style.paddingRight = '';

	if (header?.parentElement) {
		header.parentElement.style.paddingTop = '';
	}

	window.scrollTo({ top: y, behavior: 'instant' });
}
